import { FC } from 'react';
import { AllReasonsValue } from '@api/business/treatmentHook/useForecastTool';
import { HightTempIcon } from '@components/icons/meteo/HightTemp';
import { RainAndWindIcon } from '@components/icons/meteo/RainAndWind';
import { RainRiskIcon } from '@components/icons/meteo/RainRisk';
import { SmallHumidityIcon } from '@components/icons/meteo/SmallHumidity';
import { WindBoldIcon } from '@components/icons/meteo/WindBold';
import { WarningIcon } from '@components/icons/Warning.icon';
import { PlcColor } from '@styles/colors';

function getReason(value: AllReasonsValue) {
  switch (value) {
    case 'R':
      return <RainRiskIcon fillColor={PlcColor.WHITE} />;
    case 'W':
      return <WindBoldIcon fillColor={PlcColor.WHITE} />;
    case 'WR':
      return <RainAndWindIcon fillColor={PlcColor.WHITE} />;
    case 'T':
      return <HightTempIcon fillColor={PlcColor.WHITE} />;
    case 'H':
      return <SmallHumidityIcon fillColor={PlcColor.WHITE} />;
    case 'M':
      return <WarningIcon fillColor={PlcColor.WHITE} />;
    default:
      return null;
  }
}

const UiTableRowItem: FC<{
  reason: AllReasonsValue;
  color: string;
}> = ({ color, reason }) => (
  <div className={'flex-table-content-item'}>
    <div className={`treatment-schedule-td bg-${color}`}>
      <div className={`icon-reason-container bg-${color}`}>{getReason(reason)}</div>
    </div>
  </div>
);
export { UiTableRowItem };
